import { useEffect } from 'react';

import { useLocation } from '@tanstack/react-router';
import { ToastContainer } from 'react-toastify';
import { twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

import { AdminContext } from './admin-context';
import { useWidthState } from './admin-state';

export function Administrator({ children }: { children: React.ReactNode }) {
  const adminState = useWidthState();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const preLdr = document.getElementById('preloader');
    if (preLdr) {
      preLdr.classList.add('hidden!');
    }
  }, []);

  return (
    <>
      <ToastContainer
        limit={5}
        position="top-center"
        autoClose={1500}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
        toastClassName={twMerge(
          'bg-c-card! border-c-border-muted text-c-card-foreground! w-96! max-w-full items-start border pt-6 pr-9! pb-7.5 pl-6',
          'rounded-2xl!',
          cs('rounded-[2.7rem]!')
        )}
      />
      <AdminContext value={adminState}>{children}</AdminContext>
    </>
  );
}
